export default __webpack_public_path__ + "static/media/time.e4e1f75b.svg";